import customClientConfig from './customClientConfig';
import { getTenantConfig } from './config';

// Applies per-tenant browser branding (tab title + favicon) at runtime, since
// the tenant is resolved from the hostname. Tenants without these keys keep the
// defaults from public/index.html. Safe to call once on app mount.
const applyTenantBranding = () => {
  let tenant;
  try {
    ({ tenant } = getTenantConfig());
  } catch (err) {
    return;
  }

  const config = customClientConfig[tenant];
  if (!config) {
    return;
  }

  if (config.pageTitle) {
    document.title = config.pageTitle;
  }

  if (config.favicon) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = config.favicon;
  }
};

export default applyTenantBranding;
